import React from "react"
import { Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function ReportFormSectionDivider({ icon, title }) {
	return <Typography
		variant="h5"
		sx={{
			display: 'flex',
			gap: .8,
			alignItems: 'center',
			py: 1,
			pr: 2,
			borderBottom: "2px solid",
			color: "secondary.main",
			borderColor: "secondary.main"
		}}>
		<IconSeeker icon={icon} iconWeight="solid" sx={{ fontSize: "1.4rem", color: "primary.main" }}/>
		{title}
	</Typography>
}